import { render, staticRenderFns } from "./TaxRatesModal.vue?vue&type=template&id=550d09aa&scoped=true"
import script from "./TaxRatesModal.vue?vue&type=script&lang=ts"
export * from "./TaxRatesModal.vue?vue&type=script&lang=ts"
import style0 from "./TaxRatesModal.vue?vue&type=style&index=0&id=550d09aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550d09aa",
  null
  
)

export default component.exports